import React from 'react';
import AdminSidebar from '../../components/Dashboard/AdminSidebar';

const AdminDashboard = ({ children, title }) => {
  return (
    <div className="min-h-screen bg-[var(--bg-main)] pt-8 pb-20 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Sidebar */}
          <AdminSidebar />

          {/* Main Content Area */}
          <main className="flex-1 min-w-0">
            <div className="mb-8">
              <h1 className="text-3xl font-black text-[var(--text-primary)] tracking-tight mb-2">
                {title}
              </h1>
              <p className="text-[var(--text-secondary)] font-medium">
                Administrator Portal • Unified System Management
              </p>
            </div>

            <div className="bg-[var(--surface-white)] rounded-[2.5rem] shadow-xl shadow-black/5 border border-[var(--border-light)] overflow-hidden">
              {children}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
